import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearState, verifyCodeFunc } from "../../redux/Slices/authSlice";
import { toast } from "react-toastify";

const VerifyCode = () => {
  const { t } = useTranslation("global");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [code, setCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const verified = localStorage.getItem("verified");
    if (verified) {
      navigate("/login", { replace: true });
    }
  }, [navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (code.length !== 5) {
      toast.error(t("verification_code_must_be_5_digits"));
      return;
    }

    setIsLoading(true);
    dispatch(verifyCodeFunc(code))
      .unwrap()
      .then(() => {
        toast.success(t("verification_code_sent_successfully"));
        setTimeout(() => {
          localStorage.setItem("verified", "true");
          navigate("/reset_password", { replace: true });
      dispatch(clearState());
        }, 1000);
      })
      .catch((err) => {
        toast.error(t("failed_to_send_verification_code") || err?.message);
        dispatch(clearState());
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleCodeChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 5);
    setCode(value);
  };

  return (
    <main className="d-flex justify-content-center align-items-center min-vh-100">
      <div className="container">
        <form
          className="table_form form-style my-3 py-3"
          onSubmit={handleSubmit}
        >
          <div className="form-div">
            <div className="text-center my-3">
              <Link to="/">
                <picture>
                  <source srcSet="/img/fav.webp" type="image/webp" />
                  <img
                    src="/img/fav.png"
                    alt="Tripway"
                    width={180}
                    height={60}
                    decoding="async"
                    style={{ width: "auto", maxHeight: "60px", height: "60px" }}
                  />
                </picture>
              </Link>
            </div>
            
            <h1 className="h5 text-center text-md fw-bold main-color mb-4">
              <i className="bi bi-shield-lock text-lg mx-2"></i>
              {t("verification_code")}
      </h1>

            <div className="mb-3">
              <label className="fw-semibold mb-2">
                {t("verification_code")}
              </label>
      <input
        autoComplete="off"
        type="text"
        name="code"
        value={code}
                onChange={handleCodeChange}
                placeholder="00000"
                maxLength={5}
                className="form-control text-center"
                style={{
                  fontSize: "1.5rem",
                  letterSpacing: "0.5rem",
                  fontWeight: "bold",
                  padding: "0.75rem",
                }}
        required
      />
              <small className="text-muted d-block mt-2 text-center">
                {t("enter_5_digit_code") || "Enter 5-digit verification code"}
              </small>
            </div>

        <button
          type="submit"
              className="btn d-block w-100"
              disabled={isLoading || code.length !== 5}
              style={{
                backgroundColor: "var(--green-color)",
                color: "white",
                padding: "0.75rem",
                fontSize: "1rem",
                fontWeight: "600",
              }}
        >
              {isLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  {t("sign.loading")}
                </>
              ) : (
                t("btns.confirm")
              )}
        </button>

            <div className="text-center mt-3">
              <Link
                to="/login"
                className="text-decoration-none"
                style={{ color: "var(--green-color)" }}
              >
                <i className="bi bi-arrow-left me-2"></i>
                {t("back_to_login") || "Back to Login"}
              </Link>
            </div>
          </div>
        </form>
      </div>
  </main>
  );
};

export default VerifyCode;
